var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie-chart"},[_c('chart-base',{attrs:{"chart-options":_vm.options,"height":_vm.height,"width":_vm.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }